export default {
  init() {
    this.initHandlers();
  },

  initHandlers() {
    $('#removePopup').on('show.bs.modal', function (event) {
      const button = $(event.relatedTarget);
      const modal = $(this);
      modal.find('[data-delete="true"]').attr('href', button.attr('data-href'));
      modal.find('.modal-title').text('You will delete this column, are you sure?');
    });

    const exampleModal = document.getElementById('templatesPopup');
    exampleModal.addEventListener('show.bs.modal', async event => {
      const button = event.relatedTarget;
      const id = button.getAttribute('data-bs-id');
      const modalBody = exampleModal.querySelector('.modal-body');

      try {
        const response = await $.ajax({
          method: 'GET',
          url: `/api/v1/column/${id}/templates`,
          contentType: 'application/json; charset=utf-8',
          dataType: 'json',
        });

        const linksList = response.data
          .map(
            item =>
              `<li class="list-group-item">
        <a href="${item.url}" title="${item.name} (ID: ${item.id})" target="_blank">${item.name}</a>
      </li>`
          )
          .join('');

        modalBody.innerHTML =
          response.data.length > 0
            ? `<ul class="list-group">${linksList}</ul>`
            : `<p>There are no templates linked to this column</p>`;
      } catch (error) {
        modalBody.innerHTML = `<p>Something went wrong. Please try again later.</p>`;
        console.error(error);
      }
    });
  },
};
